<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Create New Car Class'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-car"></p-inputicon>
                <input
                        pInputText
                        id="car-class-name"
                        [(ngModel)]="this.carClass.name"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Car Class Name"
                />
            </p-iconfield>
            <label for="car-class-name">Car Class Name <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-tag"></p-inputicon>
                <input
                        pInputText
                        id="label"
                        [(ngModel)]="this.carClass.label"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Label (e.g., 'Luxury')"
                />
            </p-iconfield>
            <label for="label">Label <span class="text-red-500">*</span></label>
        </p-ifta-label>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="saveCarClass()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>
